export default "__VITE_ASSET__BrZsoC3a__"